import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, onMounted, ref } from 'vue';
import { RcButton, RcButtonType, RcButtonSize } from '@components/RcButton';
import { DropdownContext, defaultContext } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownTrigger',
  props: {
    size: {}
  },
  setup(__props: any, { expose: __expose }) {

/**
 * A button that opens a menu. Used in conjunction with `RcDropdown.vue`.
 */


const {
  showMenu,
  registerTrigger,
  isMenuOpen,
  handleKeydown,
} = inject<DropdownContext>('dropdownContext') || defaultContext;

const dropdownTrigger = ref<RcButtonType | null>(null);

onMounted(() => {
  registerTrigger(dropdownTrigger.value);
});

const focus = () => {
  dropdownTrigger?.value?.focus();
};

__expose({ focus });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RcButton), {
    ref_key: "dropdownTrigger",
    ref: dropdownTrigger,
    role: "button",
    "aria-haspopup": "menu",
    "aria-expanded": _unref(isMenuOpen),
    size: __props.size,
    onKeydown: _withKeys(_unref(handleKeydown), ["enter","space"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(showMenu)(true)))
  }, _createSlots({
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode()),
      _renderSlot(_ctx.$slots, "default"),
      _cache[2] || (_cache[2] = _createTextVNode())
    ]),
    _: 2
  }, [
    (_ctx.$slots.before)
      ? {
          name: "before",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "before")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.after)
      ? {
          name: "after",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "after")
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["aria-expanded", "size", "onKeydown"]))
}
}

})